function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 9.2C0 4.86308 0 2.69462 1.34731 1.34731C2.69462 0 4.86308 0 9.2 0H13.8C18.1369 0 20.3054 0 21.6527 1.34731C23 2.69462 23 4.86308 23 9.2V13.8C23 18.1369 23 20.3054 21.6527 21.6527C20.3054 23 18.1369 23 13.8 23H9.2C4.86308 23 2.69462 23 1.34731 21.6527C0 20.3054 0 18.1369 0 13.8V9.2ZM16.8667 8.43333C16.8667 6.73966 15.4937 5.36667 13.8 5.36667C12.1063 5.36667 10.7333 6.73966 10.7333 8.43333C10.7333 10.127 12.1063 11.5 13.8 11.5C15.4937 11.5 16.8667 10.127 16.8667 8.43333ZM8.43333 10.7333C9.70359 10.7333 10.7333 11.7631 10.7333 13.0333C10.7333 14.3036 9.70359 15.3333 8.43333 15.3333C7.16308 15.3333 6.13333 14.3036 6.13333 13.0333C6.13333 11.7631 7.16308 10.7333 8.43333 10.7333ZM15.3333 16.1C15.3333 15.2532 14.6468 14.5667 13.8 14.5667C12.9532 14.5667 12.2667 15.2532 12.2667 16.1C12.2667 16.9468 12.9532 17.6333 13.8 17.6333C14.6468 17.6333 15.3333 16.9468 15.3333 16.1Z",
  fill: "#6F62FF"
});

var SvgEarnSelected = function SvgEarnSelected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEarnSelected, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/earnSelected.a8fb8ce7.svg";
export { ForwardRef as ReactComponent };